import { TableColumn } from "react-data-table-component";

import { transformStringToTimeZoneAndFullTime } from "../../../utils/date-utils";
import { DataRow } from "./types";

export const ACCESS_LOG_COLUMNS: TableColumn<DataRow>[] = [
  {
    name: "Data Accessed",
    selector: (row) => row.viewedName ?? "",
  },
  {
    name: "Accessed By",
    selector: (row) => row.viewedByName ?? "",
  },
  {
    name: "Date",
    selector: (row) =>
      transformStringToTimeZoneAndFullTime(
        row.date,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        false
      ),
    cell: (row) =>
      transformStringToTimeZoneAndFullTime(
        row.date,
        Intl.DateTimeFormat().resolvedOptions().timeZone
      ),
    sortable: true,
  },
];
